const getActiveCategories = (state) => {
  return state.activeCategories
}

const getCategories = (state) => {
  return state.categories
}

const getCheckpoint = (state, getters) => (strollId, checkpointId) => {
  const stroll = getters.getStrollById(strollId)
  return stroll.checkpoints.find((checkpoint) => checkpoint.id == checkpointId)
}

const getStrolls = (state) => {
  return state.strolls
}

const getStrollById = (state) => (id) => {
  return state.strolls.find((stroll) => stroll.id == id)
}

export const getters = {
  getActiveCategories,
  getCategories,
  getCheckpoint,
  getStrollById,
  getStrolls,
}
